export const ApiRoutes = {
  BASE_URL: process.env.REACT_APP_API_GATEWAY,
  FETCH_CUSTOMER_ACCOUNTS: "api/crm/companies",
  FETCH_CONTACTS: "api/contacts",
  FETCH_SALESPERSONS: "api/crm/salesPerson",
  CREATE_JOB: "api/addLead",
  SAVE_JOB_LEAD_DRAFT: "api/crm/addLead",
  FETCH_DROPDOWN_OPTIONS: "api/dropDownOptions",
  FETCH_QUARRY_LOCATIONS: "api/quarryLocations",
  FETCH_MATERIAL_VENDOR_OPTIONS: "api/crm/vendors",
  FETCH_MATERIAL_OPTION_LIST: "api/crm/materials",
  FETCH_TOP_QUARRY_LOCATIONS: "api/crm/getTopQuarries",
  FETCH_BIDTOOL_CONFIGURATIONS: "api/settings/bidTools",
  MILES_ROUTE: "api/getMiles",
  DROPDOWN_OPTIONS: "api/dropDownOptions",
  ADD_JOB_DOCUMENTS_ROUTE: "api/documents",
  CREATE_MATERIAL_TRUCK_DETAILS: "api/crm/leads/:jobId",
  BUILD_QUOTE_GET_ESTIMATES: "api/getEstimate",
  FETCH_BID_CONFIG_INFO: "api/settings/bidTools",
  BUILD_QUOTE_UPDATE_ESTIMATE: "api/crm/leads/updateEstimate",
  ADD_CONTACT: "api/addContact",
  EDIT_CONTACT: "api/crm/companies/:companyId/contacts/:id",
  FETCH_ALL_JOBS: "api/crm/getLeads",
  FETCH_JOB_DETAIL: "api/crm/getLead",
  FETCH_INDIVIDUAL_JOB_DETAIL: "api/crm/getLead/:leadId",
  FETCH_USER_ROLE_DETAILS: "api/roles",
  ADD_USER_ROLE: "api/roles",
  MODIFY_ROLE_DETAILS: "api/roles/:id",
  APPROVE_INTERNAL_DOCUMENTS: "/api/crm/:leadId/approval",
  DELETE_DOCUMENTS: "/api/deleteRecords/documents",
  BYPASS_L2_APPROVAL: "/api/crm/bypassApproval",
  GET_QUOTE: "/api/crm/getEstimate/:leadId",
  FETCH_ALL_JOBS_MAP: "/api/crm/getMapData",
  FETCH_QUOTE_ESTIMATE_DOCUMENTS: "/api/crm/getQuoteEstimateDefaults",
  SAVE_QUOTE_ESTIMATE_DOCUMENT: "/api/crm/updateTemplateAttributes/:id",
  MAKE_DOCUMENT_PRIMARY: "/api/crm/setPrimaryTemplate/:id",
  GET_EXTERNAL_ROLES_LIST: "/api/database/roles",
  EDIT_EXTERNAL_ROLES_OPTION: "/api/database/roles/:id",
  //Ticket Upload
  FETCH_ALL_TICKETS: "/api/tickets/upload/getDashboard",
  FETCH_TICKET_TRUCKS_META: "/api/tickets/upload/getTrucksList",
  FETCH_TICKET_CUSTOMERS_META: "/api/tickets/upload/getCustomers",
  FETCH_TICKET_JOBS_META: "/api/tickets/upload/getJobs",
  FETCH_TICKET_ORDERS_META: "/api/tickets/upload/getFilterData",
  ADD_CUSTOMER: "api/addCompany",
  FETCH_TICKET_MATERIALS: "api/tickets/upload/getMaterials",
  FETCH_TICKET_VENDORS: "api/tickets/upload/getVendors",
  FETCH_TICKET_ORDER_NUMBER_META: "api/tickets/upload/getOrders",
  SAVE_TICKET: "api/tickets/upload/addTicketProcess",
  FETCH_TICKET_DETAILS: "/api/tickets/upload/getTickets/:id",
  SAVE_DATA_INPUT: "api/tickets/upload/dataInput/:id",
  REPLACE_TICKET: "api/tickets/upload/replaceTicket",
  REPLACE_FILE: "api/tickets/upload/addTicketProcess",
  //Ticket Processing
  FETCH_TICKET_PROCESSING_LISTING: "/api/tickets/processing/dashboard",
  FETCH_TICKET_PROCESSING_FILTERS: "/api/tickets/processing/getFilterData",
  UPDATE_QUARRY_ROUTE: "/api/quarryLocations/:id",
  FETCH_APPROVED_TICKETS: "/api/tickets/processing/getApprovedTickets",
  FETCH_INVOICE_META: "/api/tickets/processing/invoice/meta",
  FETCH_ARCHIVED_TICKETS: "/api/tickets/processing/archive/list",
  PATCH_ARCHIVED_TICKET: "/api/tickets/processing/archive/actions",
  FETCH_TICKET_PROCESSING_REVIEW_LIST:
    "/api/tickets/processing/getTicketsByStatus",
  FETCH_TICKET_PROCESSING_TICKET_DETAILS:
    "/api/tickets/processing/getTicketData/:id",
  SUBMIT_TICKET_FOR_PROCESSING: "/api/tickets/processing/handleTicketData/:id",
  FETCH_TICKET_PROCESSING_SECTION_COUNT:
    "/api/tickets/processing/sections/count",
  REPLACE_TKT_IN_REVIEW: "/api/tickets/processing/replaceTicket/:id",
  FETCH_RULE_ENGINE_CONTENTS: "/api/tickets/processing/getRuleEngine",
  UPDATE_RULE_ENGINE_CONTENTS: "/api/tickets/processing/updateRuleEngine/:id",
  ARCHIVE_TICKET: "/api/tickets/processing/:id/archive",
  GENERATE_INVOICES: "/api/tickets/processing/generateInvoice",
  //Invoice Management
  INITIATE_INVOICE_DOWNLOAD: "/api/invoice-management/download",
  INITIATE_INVOICE_CARRIER_DOWNLOAD:
    "/api/invoice-management/download/carrier-grouped",
  INITIATE_EXPORT_TO_QUICKBOOKS: "/api/invoice-management/export",
  FETCH_INVOICE_MANAGEMENT_TILE: "/api/invoice-management/tile-view",
  UPDATE_MATERIAL_TAX: "/api/crm/updateQuarryMaterial",
  GET_ALL_JOBS: "/api/crm/getAllJobs",
  GET_LEAD_DETAILS: "/api/crm/getLeadDetails",
  SYNC_WITH_QUICKBOOKS: "/api/finance/lien/syncFromQB",
  GET_QUICKBOOKS_SYNC_STATUS: "/api/invoice-management/non-synced-records",
  GENERATE_RECOMMENDED_DOCUMENTS: "/api/finance/lien/documents",
  DOWNLOAD_ALL_LIEN: "/api/finance/lien/downloadAllBatches",
  EXPORT_NON_SYNCED: "/api/finance/lien/exportNonSyncRecords",
  DOWNLOAD_SINGLE_BATCH: "/api/finance/lien/getBatchDocumentsZip/:batchId",
  FETCH_LIEN_DASHBOARD: "/api/finance/lien/getDashboard",
  FETCH_LIEN_FILTERS: "/api/finance/lien/filters/:filterId",
  FETCH_LIEN_DETAILS_ROUTE: "/api/finance/lien/details/:groupId",
  FETCH_LIEN_BATCH_DOCUMENTS_ROUTE:
    "/api/finance/lien/getBatchDocuments/:batchId",
  FETCH_LIEN_BATCH_DOCUMENTS_ZIP_ROUTE:
    "/api/finance/lien/getBatchDocumentsZip/:batchId",
  FETCH_INVOICE_MANAGEMENT_LIST: "/api/invoice-management",
  FETCH_INVOICE_MANAGEMENT_FILTERS:
    "/api/invoice-management/filter-options/:filterId",
  UPDATE_INVOICE_STATUS: "/api/invoice-management/:invoiceId",
  ARCHIVE_INVOICE_ROUTE: "/api/invoice-management/:invoiceId/archive",
  GET_PRESIGNED_URL_ROUTE: "/api/invoice-management/:invoiceId/file-url",
  DATABASE_TABLE_ROUTE: "/api/database/dependents/:tableType",
  DATABASE_META_ROUTE: "/api/database/meta",
  DELETE_DATABASE_TABLE_ROUTE: "/api/database/dependents/:tableType/:entityId",
  GET_CUSTOMER_DATABASE: "/api/database/customers",
  SYNC_CUSTOMER_DATABASE: "/api/database/customers/sync",
  ARCHIVE_CUSTOMER_ENTRY: "/api/database/archive/:customerId",
  GET_SPECIFIC_CUSTOMER: "/api/database/customers/:customerId",
  GET_CUSTOMER_DETAILS_FROM_GOOGLE: "/api/database/customers/details",
  GET_ACCOUNT_TERMS_OPTIONS: "/api/database/paymentTerms",
  ARCHIVE_DATABASE_ENTRY: "/api/database/archive/:id",
  LEGACY_ARCHIVE_DATABASE_RECORDS: "/database/archive/:id",
  FETCH_JOB_DATABASE_LIST: "/api/database/jobs",
  FETCH_JOB_DATABASE_SUMMARY: "/api/database/meta",
  FETCH_AFFECTED_JOB_PRICE_ERRORS: "/api/database/jobs/affected-materials",
  FETCH_JOB_DATABASE_FILTER: "/api/database/jobs/filters/:filterId",
  FETCH_JOB_DETAILS_CARD_ROUTE: "/api/database/jobs/:id",
  BLOCK_UNBLOCK_JOB: "/api/database/jobs/status/:jobId",
  BULK_SYNC_STATUS_UPDATE: "/api/invoice-management/bulk/synced",
  FETCH_QUARRY_LIST_ROUTE: "/api/database/quarries/list",
  FETCH_QUARRY_FILTER_META_ROUTE: "/api/database/quarries/filters/:id",
  ADD_NEW_QUARRY_ROUTE: "/api/database/quarries",
  FETCH_QUARRY_DETAILS_ROUTE: "/api/database/quarries/:id",
  QUARRY_MATERIAL_TABLE_LISTING: "/api/database/quarries/:id/materialProfile",
  ADD_QUARRY_MATERIAL_META: "/api/database/quarries/materials/:id",
  ADD_NEW_MATERIAL_NAME: "/api/database/quarries/dropDown/materials",
  ADD_NEW_QUARRY_MATERIAL: "/api/database/quarries/:id/material",
  GET_AFFECTED_JOBS_COUNT: "/api/database/jobs/affected-cost-count",
  GET_AFFECTED_JOBS_FOR_QUARRY_COUNT: "/api/database/quarries/affectedJobs",
  ACCEPT_REVISED_PRICE_ROUTE: "/api/database/jobs/:id/orders/:orderId/accept-revised-price",
  REJECT_REVISED_PRICE_ROUTE: "/api/database/jobs/:id/orders/:orderId/reject-revised-price",
  GET_MATERIAL_IMAGES:
    "/api/database/quarries/:quarryId/material/:materialId/images",
  FETCH_QUARRY_HEADER_DETAILS: "/api/database/quarries/:id",
  DOWNLOAD_ALL_MATERIAL_IMAGES:
    "/api/database/quarries/:quarryId/material/:materialId/images/zip",
  EDIT_QUARRY_MATERIAL: "/api/database/quarries/:id/material/:materialId",
  SYNC_QUICKBOOKS_QUARRY_ROUTE: "/api/database/quarries/sync",
  DELETE_MATERIAL_IMAGE:
    "/api/database/quarries/:quarryId/material/:materialId/images/:entryId",
  ADD_MATERIAL_IMAGES: "/api/database/quarries/images",
  UPDATE_DEPENDENTS_TABLE: "/api/database/dependents/:id/:entityId",
  UPDATE_QUARRY_PROFILE_NOTES: "/api/database/quarries/:id/notes",
  GET_QUARRIES_PRESENT_MATERIALS: "/api/database/quarries/:id/materials",
  GET_ARCHIVE_RECORDS: "/api/database/restore/archived/:type",
  ARCHIVE_RECORD_ACTIONS_ROUTE: "/api/database/restore/archived/:id",
  SEND_VIA_EMAIL_ROUTE: "/api/database/jobs/:id/orders/:orderId/sendMail",
  UPDATE_JOB_ORDER_STATUS: "api/database/jobs/:jobId/orders/:orderId/status",
  BULK_STATUS_UPDATE: "/api/invoice-management/bulk/status",
  INVOICE_RECALL_ACTION: "/api/invoice-management/:invoiceId/recall",
  INITIATE_DOWNLOAD_ORIGINAL_FILE:
    "/api/invoice-management/:invoiceId/original",
  FETCH_INVOICE_GENERATION_STATUS: "/api//invoice-management/progress",
  GET_MATERIAL_CATEGORIES_ROUTE: "/api/crm/material/categories",
  GET_MATERIAL_TYPE_ROUTE: "/api/crm/material/type",
  GET_MATERIAL_NAME_ROUTE: "/api/crm/material/label",
  GET_LOCATION_DETAILS_ROUTE: "/api/crm/coordinates",
  UPDATE_TICKET_LOCK_ROUTE: "/api/tickets/upload/:id",
  DATABASE_META_PAGINATION: "/api/database/meta",
};
